import AddDocumentDialog from './AddDocumentDialog.view';

export default AddDocumentDialog;
